<div [class]="containerStyles">
  <div class="flex items-center justify-between p-6">
    <span
      [class]="
        pickerButtonStyles +
        ' icon-chevron-left rounded-full cursor-pointer p-2'
      "
      tabindex="0"
      (keydown.enter)="$event.preventDefault(); previousMonth()"
      (keydown.space)="$event.preventDefault(); previousMonth()"
      (click)="previousMonth()"
    ></span>
    <span [class]="topTextStyles">
      <span (click)="changeView('months')" class="mr-1 cursor-pointer">{{
        localizedMonths[selectedMonth]
      }}</span>
      <span (click)="changeView('years')" class="cursor-pointer">{{
        selectedYear
      }}</span></span
    >
    <span
      [class]="
        pickerButtonStyles +
        ' icon-chevron-right rounded-full cursor-pointer p-2'
      "
      tabindex="0"
      (keydown.enter)="$event.preventDefault(); nextMonth()"
      (keydown.space)="$event.preventDefault(); nextMonth()"
      (click)="nextMonth()"
    ></span>
  </div>
  <hr [class]="dividerStyles" />
  <ng-container [ngSwitch]="view">
    <div
      *ngSwitchCase="'days'"
      class="grid grid-cols-7 grid-rows-6 items-center justify-center gap-y-2 p-6"
    >
      <div [class]="dayTextStyles" *ngFor="let day of localizedWeekdays">
        {{ day }}
      </div>
      <div
        [class]="dayBoxDisabledStyles"
        *ngFor="let day of previousMonthsDates"
      >
        {{ day }}
      </div>
      @for (day of dates; track $index) {
        @if (isInAvailableRange(day)) {
          <div
            [class]="dayBoxStyles"
            [attr.data-range]="isDayInRange(day) && !isStartOrEndDay(day)"
            [attr.data-selected]="isStartOrEndDay(day)"
            tabindex="0"
            (keydown.enter)="$event.preventDefault(); dateSelected(day)"
            (keydown.space)="$event.preventDefault(); dateSelected(day)"
            (click)="dateSelected(day)"
          >
            {{ day }}
          </div>
        } @else {
          <div [class]="dayBoxDisabledStyles">
            {{ day }}
          </div>
        }
      }
      <div [class]="dayBoxDisabledStyles" *ngFor="let day of nextMonthsDates">
        {{ day }}
      </div>
    </div>
    <div
      *ngSwitchCase="'months'"
      class="grid grid-cols-4 grid-rows-3 items-center justify-center gap-2 p-6"
    >
      <div
        [class]="monthBoxStyles"
        [attr.data-selected]="selectedMonth === i"
        *ngFor="let month of localizedMonths; let i = index"
        (click)="
          selectedMonth = i;
          view = 'days';
          updateDisplayedDates(selectedYear, selectedMonth)
        "
      >
        {{ month }}
      </div>
    </div>
    <div *ngSwitchCase="'years'" class="p-6 py-2">
      <span
        [class]="
          pickerButtonStyles +
          ' icon-chevron-up rounded-md flex items-center justify-center w-full cursor-pointer p-2'
        "
        (click)="previousYears()"
      ></span>
      <div
        class="grid grid-cols-4 grid-rows-3 items-center justify-center gap-2 py-2"
      >
        <div
          [class]="monthBoxStyles"
          [attr.data-selected]="selectedYear === year"
          *ngFor="let year of displayedYears"
          (click)="
            selectedYear = year;
            view = 'months';
            updateDisplayedDates(selectedYear, selectedMonth)
          "
        >
          {{ year }}
        </div>
      </div>
      <span
        [class]="
          pickerButtonStyles +
          ' icon-chevron-down rounded-md flex items-center justify-center w-full cursor-pointer p-2'
        "
        (click)="nextYears()"
      ></span>
    </div>
  </ng-container>
</div>
